import React from 'react';

/** Section generated from the "FaqPage" block of the Aurm design handoff. */
export default function FaqPage({ V }) {
  return (<>
    <div>{" "}
      <section data-r="pad" style={{ maxWidth: "1200px", margin: "0 auto", padding: "112px 40px 64px" }}>{" "}
        <p style={{ display: "flex", alignItems: "center", gap: "12px", fontSize: "12px", fontWeight: "600", letterSpacing: ".22em", textTransform: "uppercase", color: "rgba(255,255,255,.72)" }}>
          <span aria-hidden="true" style={{ width: "22px", height: "1px", background: "#DB2349", flex: "none" }}></span>Help
        </p>{" "}
        <h1 style={{ marginTop: "26px", fontSize: "clamp(44px,6vw,80px)", lineHeight: "1", letterSpacing: "-.04em", fontWeight: "600" }}>Frequently asked questions</h1>{" "}
      </section>{" "}
      <section data-r="pad" style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 40px", display: "flex", flexWrap: "wrap", gap: "56px", alignItems: "flex-start" }}>{" "}
        <aside style={V.faqAside}>{" "}
          <label style={{ position: "relative", display: "block" }}>{" "}
            <span style={{ position: "absolute", width: "1px", height: "1px", overflow: "hidden", clip: "rect(0 0 0 0)" }}>Search questions</span>{" "}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.55)" strokeWidth="2" aria-hidden="true" style={{ position: "absolute", left: "18px", top: "50%", transform: "translateY(-50%)" }}>
              <circle cx="11" cy="11" r="7"></circle>
              <path d="M20 20l-4-4"></path>
            </svg>{" "}
            <input type="search" value={V.faqQuery} onInput={V.onFaqQuery} placeholder="Search questions" style={{ width: "100%", height: "52px", padding: "0 18px 0 48px", borderRadius: "999px", border: "1px solid rgba(255,255,255,.16)", background: "rgba(255,255,255,.05)", color: "#fff", fontSize: "15px", outline: "none" }} />{" "}
          </label>{" "}
          <nav aria-label="FAQ topics" style={{ display: "flex", flexDirection: "column", gap: "4px" }}>{" "}
            {(V.faqGroups || []).map((g, $index) => (
              <React.Fragment key={$index}>{" "}
              <a className="aurm-hf" href={g.anchor} style={{ display: "flex", justifyContent: "space-between", gap: "12px", padding: "12px 16px", borderRadius: "14px", fontSize: "15px", fontWeight: "500", color: "rgba(255,255,255,.82)" }}>{g.title}
                <span style={{ color: "rgba(255,255,255,.5)", fontVariantNumeric: "tabular-nums" }}>{g.count}</span>
              </a>{" "}
              </React.Fragment>
            ))}{" "}
          </nav>{" "}
          <div style={{ padding: "24px", borderRadius: "22px", border: "1px solid rgba(255,255,255,.12)", background: "linear-gradient(180deg,rgba(46,30,78,.97),rgba(34,20,60,.97))", display: "flex", flexDirection: "column", gap: "14px" }}>{" "}
            <p style={{ fontSize: "17px", fontWeight: "600" }}>Still have a question?</p>{" "}
            <p style={{ fontSize: "14px", lineHeight: "1.55", color: "rgba(255,255,255,.7)" }}>The team answers on WhatsApp, usually within the hour.</p>{" "}
            <a href={V.waGeneral} target="_blank" rel="noopener noreferrer" style={{ alignSelf: "flex-start", display: "inline-flex", alignItems: "center", height: "44px", padding: "0 20px", borderRadius: "999px", background: "linear-gradient(180deg,#e5385c 0%,#DB2349 55%,#c91f43 100%)", fontSize: "14px", fontWeight: "600" }}>WhatsApp us</a>{" "}
          </div>{" "}
        </aside>{" "}
        <div style={{ flex: "999 1 520px", minWidth: "0", display: "flex", flexDirection: "column", gap: "56px" }}>{" "}
          {(V.faqGroups || []).map((g, $index) => (
            <React.Fragment key={$index}>{" "}
            <div id={g.id} style={{ scrollMarginTop: "110px" }}>{" "}
              <h2 style={{ fontSize: "13px", fontWeight: "600", letterSpacing: ".2em", textTransform: "uppercase", color: "#ff8a9c" }}>{g.title}</h2>{" "}
              <div style={{ marginTop: "12px" }}>{" "}
                {(g.items || []).map((f, $index) => (
                  <React.Fragment key={$index}>{" "}
                  <div style={{ borderBottom: "1px solid rgba(255,255,255,.1)" }}>{" "}
                    <button type="button" onClick={f.toggle} aria-expanded={f.expanded} style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "24px", padding: "24px 0", border: "0", background: "none", color: "#fff", cursor: "pointer", textAlign: "left", fontSize: "19px", fontWeight: "500", lineHeight: "1.4" }}>{f.q}
                      <span aria-hidden="true" style={f.sign}>+</span>
                    </button>{" "}
                    <div data-acc={f.open} style={{ display: "grid" }}>
                      <div style={{ minHeight: "0", overflow: "hidden" }}>
                        <p style={{ margin: "0", padding: "0 48px 26px 0", fontSize: "16px", lineHeight: "1.7", color: "rgba(255,255,255,.76)" }}>{f.a}</p>
                      </div>
                    </div>{" "}
                  </div>{" "}
                  </React.Fragment>
                ))}{" "}
              </div>{" "}
            </div>{" "}
            </React.Fragment>
          ))}{" "}
          {V.faqEmpty ? (<>
            <p style={{ fontSize: "17px", color: "rgba(255,255,255,.7)" }}>No questions match that search. Ask the team on WhatsApp instead.</p>
          </>) : null}{" "}
        </div>{" "}
      </section>
    </div>
  </>);
}
